import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { exportParameters } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation, useQueryClient } from 'react-query';


export const useCreateExportParameters = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  const {
    isLoading,
    isSuccess,
    isError,
    mutate,
    reset,
  } = useMutation(
    async ({ partnerAccountID, parameters }) => axiosInstance.post(
      exportParameters(orgId).create(partnerAccountID),
      {
        organizationID: orgId,
        partnerAccountID,
        parameters,
      },
    ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['CreateExportParameters', orgId] });
        dispatch(showAlert({ message: 'Export parameters created successfully.', type: 'success' }));
      },
      onError: (err) => {
        dispatch(showAlert({
          message: err.response?.data?.message || 'Failed to create export parameters.',
          type: 'error',
        }));
      },
    },
  );

  return {
    isLoading,
    isError,
    isSuccess,
    mutate,
    reset,
  };
};
